import axios from 'axios';
import { toast } from 'react-toastify';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '/api/v1',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const isPublicAuthRoute = /\/auth\/(login|register)/.test(config.url || '');
    if (!isPublicAuthRoute) {
      const token =
        localStorage.getItem('token') ?? sessionStorage.getItem('token');
      if (token) config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default api;

export const getConfigWithBearerToken = () => {
  const token =
    localStorage.getItem('token') ?? sessionStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const handleApiError = (apiName, error, rejectWithValue) => {
  console.error(`${apiName} Error:`, error.message);

  if (error.code === 'ECONNABORTED') {
    return rejectWithValue({
      message:
        'The request timed out before the server responded. The mapping may still have completed — check server logs for the final result.',
    });
  }

  if (error.response) {
    return rejectWithValue({
      status: error.response.status,
      message:
        error.response.data?.error ||
        error.response.data?.message ||
        'An error occurred',
    });
  }

  return rejectWithValue({
    message: error.message || 'Network error or server not reachable',
  });
};

const notify = (type, text) => {
  toast[type](<>{text}</>, {
    theme: 'dark',
  });
};

export const notifyMsg = (response) => {
  if (response?.success) {
    notify('success', response?.message);
  } else {
    notify('error', response?.message || 'Something went wrong');
  }
};
